import { render, staticRenderFns } from "./Trophies.vue?vue&type=template&id=51c25bc0&"
import script from "./Trophies.vue?vue&type=script&lang=js&"
export * from "./Trophies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports